/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solution_HeadlineInputs */

const en_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader can help`)
};

const de_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader hilft dir dabei`)
};

const zh_tw_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader 可以幫你`)
};

const zh_cn_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader 可以帮你`)
};

const es_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader te ayuda`)
};

const fr_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader peut t'aider`)
};

const it_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader ti dà una mano`)
};

const pt_br_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Vibe Reader te ajuda`)
};

const ja_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader が力になれます`)
};

const ko_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader가 도와줄 수 있어요`)
};

const ru_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader поможет тебе`)
};

const th_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader ช่วยคุณได้`)
};

const tr_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader sana yardımcı olabilir`)
};

const ar_solution_headline = /** @type {(inputs: Solution_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader هنا لمساعدتك`)
};

/**
* | output |
* | --- |
* | "Vibe Reader can help" |
*
* @param {Solution_HeadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const solution_headline = /** @type {((inputs?: Solution_HeadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solution_HeadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solution_headline(inputs)
	if (locale === "de") return de_solution_headline(inputs)
	if (locale === "zh_tw") return zh_tw_solution_headline(inputs)
	if (locale === "zh_cn") return zh_cn_solution_headline(inputs)
	if (locale === "es") return es_solution_headline(inputs)
	if (locale === "fr") return fr_solution_headline(inputs)
	if (locale === "it") return it_solution_headline(inputs)
	if (locale === "pt_br") return pt_br_solution_headline(inputs)
	if (locale === "ja") return ja_solution_headline(inputs)
	if (locale === "ko") return ko_solution_headline(inputs)
	if (locale === "ru") return ru_solution_headline(inputs)
	if (locale === "th") return th_solution_headline(inputs)
	if (locale === "tr") return tr_solution_headline(inputs)
	return ar_solution_headline(inputs)
});